module.exports = __webpack_public_path__ + "static/media/washer.77723ced.svg";